import { render, staticRenderFns } from "./CoreMarketingDashboard.vue?vue&type=template&id=4c4d6af6"
import script from "./CoreMarketingDashboard.vue?vue&type=script&lang=js"
export * from "./CoreMarketingDashboard.vue?vue&type=script&lang=js"
import style0 from "./CoreMarketingDashboard.vue?vue&type=style&index=0&id=4c4d6af6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports